import { useState, useEffect, useMemo } from "react";
import { BiPlus } from "react-icons/bi";
import { GrAscend, GrDescend } from "react-icons/gr";
import { PiMagnifyingGlass } from "react-icons/pi";
import { VscOrganization } from "react-icons/vsc";
import TableRowsLoader from "../Loaders/TableRowsLoader";
import { TbReload } from "react-icons/tb";
import WorkflowsTable from "./WorkflowsTable";
import NewWorkflowModal from "./NewWorkflowModal";
import { useParams } from "react-router-dom";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const MainWorkflow = ({
    account_id,
    userData,
    orgData,
    fetchOrgData
}) => {
    const {org_id} = useParams()
    const [openModal, setOpenModal] = useState(false);
    const [openModalUpdate, setOpenModalUpdate] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const [data, setDatata] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedMember, setSelectedMember] = useState({})

    const fetchData = async () => {
        if (!account_id) return;
        setLoading(true);
        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/get_workflows`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ 
                    account_id,
                    org_id,
                    limit: 20,
                    offset: 0,
                 }),
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.error || "Failed to fetch");

            setDatata(result.data || []);
        } catch (err) {
            console.error("Error fetching members:", err);
        } finally {
            setTimeout(() => setLoading(false), 500);
        }
    };

    useEffect(() => {
        fetchData();
    }, [account_id]);

    const filteredAndSortedData = useMemo(() => {
        if (!data) return [];

        let result = data.filter((member) => {
            const term = searchTerm.toLowerCase();
            const nameMatch = `${member.name} ${member.surname}`.toLowerCase().includes(term);
            const emailMatch = member.email?.toLowerCase().includes(term);
            const statusMatch = member.status?.toLowerCase().includes(term);

            const orgMatch = member.organizations?.some(org =>
                org.name?.toLowerCase().includes(term)
            );

            return nameMatch || emailMatch || orgMatch || statusMatch;
        });

        result.sort((a, b) => {
            const nameA = a.name?.toLowerCase() || "";
            const nameB = b.name?.toLowerCase() || "";
            return sortOrder === "asc"
                ? nameA.localeCompare(nameB)
                : nameB.localeCompare(nameA);
        });

        return result;
    }, [data, searchTerm, sortOrder]);

    const handleOpenModalUpdate = (item) => {
        setSelectedMember(item)
        setOpenModalUpdate(true)
    }

    if (loading) return <TableRowsLoader />;

    return (
        <div className="mainframe_item">
            <div className="mainframe_item_header">
                <p className="mainframe_item_title fade-in">Workflows</p>
                <div className="mainframe_item_subtitle fade-in">
                    {data.length === 0 ? (
                        <div className="empty_org_mex_cont">
                            <p>
                                Automate your tasks by creating workflows that can run instantly or on a schedule.
                            </p>
                            <div className="empty_org_img">
                                <p className="empty_org_img_title">
                                    <i><VscOrganization /></i> What is a workflow?
                                </p>
                                <p className="empty_org_img_subtitle">
                                    Use AI-powered workflows to automate repetitive tasks and streamline your processes.
                                    Trigger them on demand or schedule them to run automatically in the background.
                                </p>
                            </div>
                        </div>
                    ) : (
                        <p>
                            View, manage, and monitor all your workflows in one place.
                        </p>
                    )}
                </div>
                {/* <p className="soon_av">Soon available</p> */}
                {/* <button className="mainframe_item_create_btn fade-in" onClick={() => setOpenModal(true)}>
                    <BiPlus /> Create
                </button> */}
                <p className="soon_av">Soon available</p>
            </div>

            {(data.length > 0 || searchTerm) && (
                <div className="filter_body_mainframe">
                    <div className="filtering_mainframe">
                        <div className="filtering_mainframe_btn_cont fade-in">
                            {data.length > 1 && (
                                <>
                                    <button className={`filter_btn ${sortOrder === "asc" ? "active" : ""}`} onClick={() => setSortOrder("asc")}>
                                        <GrAscend />
                                    </button>
                                    <button className={`filter_btn ${sortOrder === "desc" ? "active" : ""}`} onClick={() => setSortOrder("desc")}>
                                        <GrDescend />
                                    </button>
                                </>
                            )}
                            <button className="filter_btn" onClick={() => fetchData()} title="Reload Data">
                                <TbReload />
                            </button>
                        </div>
                        <div className="filter_input_cont fade-in">
                            <input
                                className="filter_input"
                                placeholder="Search by name, description and more..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <span className="filter_input_icon"><PiMagnifyingGlass /></span>
                        </div>
                    </div>

                    <WorkflowsTable
                        type="members"
                        data={filteredAndSortedData}
                        handleOpenModalUpdate={handleOpenModalUpdate}
                        userData={userData}
                    />
                </div>
            )}

            <NewWorkflowModal
                account_id={account_id}
                show={openModal}
                handleClose={() => setOpenModal(false)}
                fetchRecords={fetchData}
                userData={userData}
                orgData={orgData}
                fetchOrgData={fetchOrgData}
            />



        </div>
    );
};

export default MainWorkflow;